import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import VueAuth from "@websanova/vue-auth";
import Multiselect from "vue-multiselect";
import auth from "./auth.js";
import { BootstrapVue } from "bootstrap-vue";
import Vuex from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBed as falBed,
  faBath as falBath,
  faHomeAlt as falHomeAlt,
  faQuestionCircle as falQuestionCircle,
  faExclamationCircle as falExclamationCircle,
  faGlobe as falGlobe,
  faSignOut as falSignOut,
  faCarGarage as falCarGarage,
  faWarehouseAlt as falWarehouseAlt,
  faBuilding as falBuilding,
  faSeedling as falSeedling,
  faMale as falMale,
  faGamepad as falGamepad,
  faMoneyCheckAlt as falMoneyCheckAlt,
  faFilePdf as falFilePdf,
  faBookUser as falBookUser,
  faFileInvoiceDollar as falFileInvoiceDollar,
  faFileAlt as falFileAlt,
  faFileContract as falFileContract,
  faFileSignature as falFileSignature,
  faLeaf as falLeaf,
  faDumbbell as falDumbbell,
  faDoorClosed as falDoorClosed,
  faChartLine as falChartLine,
  faCamera as falCamera,
  faImages as falImages,
  faPlus as falPlus,
  faGarageCar as falGarageCar,
  faFileSearch as falFileSearch,
  faBars as falBars,
  faCaretRight as falCaretRight,
} from "@fortawesome/pro-light-svg-icons";
import {
  faUserSecret as fasUserSecret,
  faCircle as fasCircle,
  faCheck as fasCheck,
  faCreditCard as fasCreditCard,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faFacebookF,
  faInstagram,
  faWhatsapp,
  faCcMastercard,
  faCcVisa,
  faCcDinersClub,
  faCcAmex,
} from "@fortawesome/free-brands-svg-icons";
import {
  faHourglass as farHourglass,
  faBars as farBars,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faBuildingColumns as fadBuildingColumns,
  faArrowRight as fadArrowRight,
  faBrowser as fadBrowser,
} from "@fortawesome/pro-duotone-svg-icons";
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from "@fortawesome/vue-fontawesome";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import "bootstrap/dist/css/bootstrap.css";
import "vue-search-select/dist/VueSearchSelect.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import JwPagination from "jw-vue-pagination";
import Pagination from "vue-pagination-2";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

Vue.config.productionTip = false;
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  params: {},
});
library.add(
  farHourglass,
  fasUserSecret,
  fasCircle,
  fasCheck,
  faFacebookF,
  faWhatsapp,
  faInstagram,
  falBed,
  falBath,
  falHomeAlt,
  falQuestionCircle,
  falExclamationCircle,
  falGlobe,
  falSignOut,
  falCarGarage,
  falWarehouseAlt,
  falBuilding,
  falSeedling,
  falMale,
  falGamepad,
  falMoneyCheckAlt,
  falFilePdf,
  falBookUser,
  falFileInvoiceDollar,
  falFileAlt,
  falFileContract,
  falFileSignature,
  falLeaf,
  falDumbbell,
  falDoorClosed,
  falChartLine,
  falGarageCar,
  falCamera,
  falImages,
  falPlus,
  falFileSearch,
  falBars,
  falCaretRight,
  fadBuildingColumns,
  fadArrowRight,
  fadBrowser,
  faCcMastercard,
  faCcVisa,
  faCcDinersClub,
  faCcAmex,
  fasCreditCard,
  farBars
);
Vue.use(VueAxios, instance);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);
Vue.component("font-awesome-layers-text", FontAwesomeLayersText);
Vue.component("multiselect", Multiselect);
Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);

Vue.component("jw-pagination", JwPagination);
Vue.component("pagination", Pagination);
Vue.router = router;
App.router = Vue.router;
Vue.use(VueMoment, { moment });
Vue.use(VueAuth, auth);
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    customer: null,
    customerData: null,
    quoteApiVersion: "v2",
    quote_api: process.env.VUE_APP_API_CUSTOMER_URL,
    customer_link: process.env.VUE_APP_CUSTOMER_LINK,
    customer_backend: process.env.VUE_APP_CUSTOMER_BACKEND,
    customer_site: process.env.VUE_APP_CUSTOMER_SITE,
    customer_site_api: process.env.VUE_APP_CUSTOMER_API_URL,
    integration_url: process.env.VUE_APP_API_INTEGRATION_URL,
    customerDomain: null,
    customer_color: "#B12424",
    Apartments: [],
    observations: [],
    loading: false,
    projects: null,
    complementaries: null,
    oportunities: null,
    notices: null,
    slides: null,
    header: null,
    uf: null,
    color1: null,
    color2: null,
    color3: null,
    inputColor1: null,
    inputColor2: null,
    selectColor: null,
    selectTextColor: null,
    infoAlertColor: null,
    infoAlertTextColor: null,
    buttonTextColor: null,
    haveAftersale: [],
    tokus: [],
    contract_id: null,
    cards: null,
    automated: null,
    subDomain: null,
  },
  mutations: {
    setApartments: (state, apr) => {
      if (apr) {
        state.apartments = apr.assets;
        state.haveAftersale = apr.have_aftersale;
      }
    },
    removeApartments: (state) => {
      state.apartments = [];
    },
    addObservation(state, observation) {
      state.observations.push(observation);
    },
    deleteObservation(state, position) {
      state.observations.splice(position, 1);
    },
    setRequest: (state, reception) => {
      state.reception = reception;
    },
    setCustomer: (state, data) => {
      state.customer = data;
      state.customerDomain = `https://${data}.mobysuite.com/`;
    },
    setProjects(state) {
      instance
        .get(
          state.quote_api + state.quoteApiVersion + "/quotes/list-projects",
          {
            params: {
              real_estate: state.subDomain,
            },
          }
        )
        .then((response) => {
          state.projects = response.data;
          state.loading = false;
        });
    },
    setNotices(state) {
      state.notices = null;
      /*
      state.loading = true;
      instance.get(state.customer_site_api + "/notices").then((response) => {
        state.notices = response.data;
        state.loading = false;
      });
	  */
    },
    setCustomerData(state) {
      if (state.customer) {
        instance
          .get("clients/list-real-estate-info-with-virtual-sale-room", {
            params: {
              customer_id: state.customer,
            },
          })
          .then((response) => {
            state.customerData = response.data;
            state.quoteApiVersion = response.data.gc_version == 1 ? "v2" : "v3";
            state.subDomain = response.data.sub_domain;
            store.commit("setProjects");
            state.customerData.template = response.data.template || "default";
            const favicon = document.getElementById("favicon");
            favicon.href = response.data.favicon_url;
          });
      }
    },
    setUf(state) {
      state.uf = null;
      /*
			instance.get(state.customer_site_api+"/extras/get_uf").then((response)=>{
				state.uf = response.data;
			});*/
    },
    setOportunities(state) {
      state.oportunities = null;
      /*
			instance.get(state.customer_site_api+"/oportunities").then((response)=>{
				state.oportunities = response.data;
			});*/
    },
    setCards(state) {
      instance.get("payments/oneclick").then((result) => {
        state.cards = result.data;
        if (result.data.length > 0) store.commit("setAutomatedPayments", true);
      });
    },
    setTokus(state) {
      instance.get("payments/get_toku_automatic_payments").then((response) => {
        state.tokus = response.data.response;
      });
    },
    setContractId(state, contract) {
      state.contract_id = contract;
    },
    setAutomatedPayments(state, have) {
      state.automated = have;
    },
  },
  actions: {
    setTokus(context) {
      context.commit("setTokus");
    },
    setProjects(context) {
      context.commit("setProjects");
    },
    setCustomer(context, data) {
      context.commit("setCustomer", data);
    },
    setNotices(context) {
      context.commit("setNotices");
    },
    setApartments(context) {
      context.commit("setApartments");
    },
    setHeader(context, page) {
      context.commit("setHeader", page);
    },
    setUf(context) {
      context.commit("setUf");
    },
    setOportunities(context) {
      context.commit("setOportunities");
    },
    setCards(context) {
      context.commit("setCards");
    },
    setAutomatedPayments(context) {
      context.commit("setAutomatedPayments");
    },
  },
  getters: {
    getCustomer: (state) => {
      return state.customer;
    },
    getIntegrationUrl: (state) => {
      return state.integration_url;
    },
    getCustomerData: (state) => {
      return state.customerData;
    },
    getCustomerDomain: (state) => {
      return state.customerDomain;
    },
    getApartmentById: (state) => (id) => {
      let apartment = state.apartments.find(
        (apartment) => apartment.asset_id === id
      );
      if (apartment) {
        state.phone = apartment.project_phone;
      }
      return apartment;
    },
    getProjects(state) {
      return state.projects;
    },
    getProjectByMoby: (state) => (project_id) => {
      return state.projects
        ? state.projects.find((project) => project.id == project_id)
        : null;
    },
    getCards(state) {
      return state.cards;
    },
    getTokus(state) {
      return state.tokus;
    },
    getContractId(state) {
      return state.contract_id;
    },
    getAutomatedPayments(state) {
      return state.automated;
    },
  },
});

Vue.filter("numberFormat", function (value) {
  let roundedValue = Math.round(value * 100) / 100;
  let number = roundedValue.toString().split(".");
  let numberFormated =
    number.length > 1
      ? number[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + number[1]
      : number[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return numberFormated ? numberFormated : 0;
});

new Vue({
  components: {},
  router,
  store,
  validations: {},
  axios,
  render: (h) => h(App),
}).$mount("#app");
